import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SdThemeComponent } from '../abstract/theme/theme.component';

@Component({
  selector: 'sd-theme-wrapper',
  templateUrl: './theme-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SdThemeWrapperComponent extends SdThemeComponent {}
